export const capitalizePronouns = (pronouns: string) => {
  return pronouns
    .split('/')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('/');
};
